import Axios from '../Axios';

const group = {
	create(data) {
		return Axios.post('/groups', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get('/groups?&limit=' + limit + '&page=' + page + search);
	},
	readOne(id) {
		return Axios.get('/groups/' + id);
	},
	update(id, data) {
		return Axios.put('/groups/' + id, data);
	},
	delete(id) {
		return Axios.delete('/groups/' + id);
	},
};

export default group;
